module.exports = __webpack_public_path__ + "static/media/teacher.df1a11f9.svg";